import {format, utcToZonedTime} from "date-fns-tz";

export interface LocalizedDate {
  date: string;
  timezone: string;
}

export function getLocalizedDate(localizedDate: LocalizedDate | string, outputFormat = 'PPPp (z)') {
  if (typeof localizedDate === 'string') {
    return format(new Date(localizedDate), outputFormat);
  }

  const zonedTime = utcToZonedTime(localizedDate.date, localizedDate.timezone);
  return format(zonedTime, outputFormat, {timeZone: localizedDate.timezone});
}
